
import { Booking } from '@/types/booking';
import { addDays, subDays } from 'date-fns';

const today = new Date();

export const mockBookings: Booking[] = [
  {
    id: '1',
    companyName: 'Statoil',
    contactName: 'Anne Hansen',
    contactEmail: 'anne.hansen@statoil.com',
    contactPhone: '98765432',
    startDate: subDays(today, 5),
    endDate: addDays(today, 10),
    price: 35000,
    placement: 'top',
    status: 'aktiv',
    articleTitle: 'Fremtidens energiløsninger i Norge',
  },
  {
    id: '2',
    companyName: 'DNB',
    contactName: 'Per Olsen',
    contactEmail: 'per.olsen@dnb.no',
    contactPhone: '87654321',
    startDate: addDays(today, 2),
    endDate: addDays(today, 16),
    price: 28000,
    placement: 'normal',
    status: 'planlagt',
    articleTitle: 'Økonomiske utsikter for neste kvartal',
  },
  {
    id: '3',
    companyName: 'Telenor',
    contactName: 'Lise Jensen',
    contactEmail: 'lise.jensen@telenor.no',
    contactPhone: '76543210',
    startDate: subDays(today, 20),
    endDate: subDays(today, 6),
    price: 42000,
    placement: 'top',
    status: 'fullført',
    articleTitle: 'Ny teknologi for fremtidens kommunikasjon',
  },
  {
    id: '4',
    companyName: 'NorgesGruppen',
    contactName: 'Knut Larsen',
    contactEmail: 'knut.larsen@norgesgruppen.no',
    contactPhone: '65432109',
    startDate: addDays(today, 4),
    endDate: addDays(today, 25),
    price: 31500,
    placement: 'top',
    status: 'planlagt',
    notes: 'Ønsker fornyet avtale ved utgangen av perioden',
  },
  {
    id: '5',
    companyName: 'Storebrand',
    contactName: 'Mette Andersen',
    contactEmail: 'mette.andersen@storebrand.no',
    contactPhone: '54321098',
    startDate: subDays(today, 10),
    endDate: addDays(today, 5),
    price: 26000,
    placement: 'normal',
    status: 'aktiv',
    articleTitle: 'Pensjonssparing for unge profesjonelle',
  },
];
